import React from 'react';
import Shimmer from './Shimmer';

const GeographyShimmer = () => {
    const items = Array(3).fill(null);

    return (
        <section className="bg-gradient-to-br from-zinc-50 to-white py-24">
            <div className="max-w-7xl mx-auto px-4">
                {/* Header Shimmer */}
                <div className="relative text-center mb-24">
                    <Shimmer className="h-12 w-72 mx-auto rounded-lg"/>
                    <div className="absolute w-24 h-1 bottom-0 left-1/2 transform -translate-x-1/2 translate-y-8">
                        <Shimmer className="h-full w-full rounded"/>
                    </div>
                </div>

                {/* Content Shimmer */}
                <div className="relative space-y-32">
                    {items.map((_, index) => (
                        <div key={index} className="relative">
                            <div className={`flex flex-col md:flex-row ${
                                index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                            } items-start gap-16`}>
                                {/* Icon Shimmer */}
                                <div className="w-full md:w-1/3 flex justify-center">
                                    <div className="relative">
                                        {/* Background blur effect shimmer */}
                                        <div className="absolute -inset-4 bg-gray-100 rounded-full blur-2xl"/>

                                        {/* Icon container shimmer */}
                                        <div className="relative w-24 h-24">
                                            <Shimmer className="w-full h-full rounded-full"/>
                                            <div className="absolute inset-0 border-2 border-gray-300 rounded-full"/>
                                        </div>
                                    </div>
                                </div>

                                {/* Content Shimmer */}
                                <div className="flex-1 space-y-6">
                                    <div className="space-y-4">
                                        {/* Title Shimmer */}
                                        <Shimmer className="h-8 w-64 rounded-lg"/>

                                        {/* Description Shimmer */}
                                        <div className="space-y-2">
                                            <Shimmer className="h-4 w-full rounded"/>
                                            <Shimmer className="h-4 w-3/4 rounded"/>
                                        </div>
                                    </div>

                                    {/* Button Shimmer */}
                                    <div className="pb-8">
                                        <Shimmer className="h-6 w-32 rounded"/>
                                    </div>
                                </div>
                            </div>

                            {/* Timeline connector Shimmer */}
                            {index < items.length - 1 && (
                                <div className="absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-full">
                                    <div className="relative h-32">
                                        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-px h-full">
                                            <div
                                                className="w-full h-full bg-gradient-to-b from-gray-200 to-transparent"/>
                                        </div>
                                        <Shimmer
                                            className="absolute top-0 left-1/2 transform -translate-x-1/2 w-2 h-2 rounded-full"/>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default GeographyShimmer;